import { popupCenter, removeScript } from '../../helpers';
export const APPLE_CONFIG = {
    response_type: 'code+id_token',
    response_mode: 'form_post',
    scope: 'openid+name+email',
    usePopup: true,
};
export class LoginWithAppleHandler {
    static SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    static SDK_ID = 'apple-sdk';
    configs;
    constructor(clientId, ssoServerUrl) {
        this.configs = { clientId, ssoServerUrl };
    }
    signIn(options) {
        return new Promise(async (resolve) => {
            const uxMode = options?.uxMode || 'popup';
            const url = this.getLoginUrl({
                redirectUrl: options?.redirectUrl ||
                    `${this.configs.ssoServerUrl}v2/public/auth/social/apple/redirect`,
                uxMode,
                state: Object.assign({ uxMode }, options?.state),
            });
            if (options?.uxMode === 'redirect') {
                window.location.href = url;
                return resolve(['']);
            }
            try {
                const contentWindow = popupCenter({
                    url,
                });
                if (!contentWindow)
                    return resolve([undefined, 'Cannot open login window']);
                const intervalId = setInterval(() => {
                    if (contentWindow.closed) {
                        clearInterval(intervalId);
                        resolve([undefined, 'You have cancelled login or did not fully authorize']);
                    }
                }, 1000);
                window.addEventListener('message', event => {
                    if (event.origin === window.location.origin) {
                        const data = event.data;
                        if (data && data.type === 'login_apple_success') {
                            contentWindow.close();
                            return resolve([data.payload.idToken]);
                        }
                    }
                });
            }
            catch (e) {
                return resolve([
                    undefined,
                    //@ts-ignore
                    e instanceof Error ? e.message : e?.error || 'Something went wrong!',
                ]);
            }
        });
    }
    signOut() {
        //TODO:
        console.debug('sign out');
    }
    async loadSDK() {
        return true;
    }
    getLoginUrl(opts) {
        const params = Object.entries({
            client_id: this.configs.clientId,
            redirect_uri: opts.redirectUrl,
            response_type: 'code+id_token',
            response_mode: 'form_post',
            scope: 'openid+name+email',
            state: encodeURIComponent(JSON.stringify(opts.state)),
        })
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        return `https://appleid.apple.com/auth/authorize?${params}`;
    }
    removeSDK() {
        removeScript(LoginWithAppleHandler.SDK_ID);
    }
}
//# sourceMappingURL=apple.js.map